import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import lashmaLogo from '../assets/images/lashma.png';

const IleraBanner = () => {
  return (
    <Box 
      sx={{ 
        width: "100%", 
        mb: 6,
        overflow: 'hidden',
        position: 'relative',
        cursor: 'pointer',
        background: 'linear-gradient(135deg, #ff6d00 0%, #bf360c 100%)', // Deep, sophisticated orange
        boxShadow: '0px 10px 30px rgba(191, 54, 12, 0.4)',
        borderRadius: { xs: '0', md: '16px' },
        border: '1px solid rgba(255, 255, 255, 0.1)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.15) 0%, transparent 50%)',
          pointerEvents: 'none',
        }
      }}
    >
      <a 
        href="https://ileraeko.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        style={{ textDecoration: 'none' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: { xs: '40px 24px', md: '50px 80px' },
            minHeight: { xs: '280px', md: '220px' },
            position: 'relative',
            transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              '& .banner-content': {
                transform: 'translateY(-5px)',
              },
              '& .logo-overlay': {
                transform: 'scale(1.08) rotate(2deg)',
                opacity: 0.4,
              }
            },
          }}
        >

          <Box 
            className="banner-content"
            sx={{ 
              color: 'white', 
              maxWidth: { xs: '100%', md: '65%' }, 
              textAlign: { xs: 'center', md: 'left' },
              zIndex: 2,
              transition: 'transform 0.4s ease-in-out'
            }}
          >
            <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: '900', 
                fontSize: { xs: '2.2rem', md: '3.8rem' },
                letterSpacing: '-1px',
                mb: 1,
                lineHeight: 1,
                textShadow: '0px 4px 10px rgba(0,0,0,0.2)'
              }}
            >
              ILERA EKO
            </Typography>
            
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: '600', 
                fontSize: { xs: '1.1rem', md: '1.6rem' },
                opacity: 0.95,
                lineHeight: 1.3,
                mb: 4,
                textShadow: '0px 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              Lagos State Health Insurance Scheme. <br />
              <Typography component="span" sx={{ fontWeight: '400', fontSize: 'inherit', opacity: 0.8 }}>
                Quality healthcare made affordable for every resident.
              </Typography>
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: '#fff',
                color: '#bf360c',
                fontWeight: '900',
                px: { xs: 5, md: 7 },
                py: { xs: 1.5, md: 2 },
                borderRadius: '12px',
                fontSize: '1.1rem',
                textTransform: 'none',
                boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.2)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: '#fbe9e7',
                  transform: 'scale(1.05)',
                  boxShadow: '0px 15px 35px rgba(0, 0, 0, 0.3)',
                },
              }}
            >
              Enrol Now
            </Button>
          </Box>

          {/* Logo Container */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#fff',
              width: { xs: '120px', md: '180px' },
              height: { xs: '120px', md: '180px' },
              borderRadius: '50%',
              boxShadow: '0px 10px 30px rgba(0,0,0,0.2)',
              zIndex: 2,
              p: 2,
              mt: { xs: 4, md: 0 },
              transition: 'all 0.4s ease',
              '&:hover': {
                transform: 'scale(1.05) rotate(5deg)',
              }
            }}
          >
             <img 
               src={lashmaLogo} 
               alt="LASHMA" 
               style={{ 
                 width: '100%',
                 height: 'auto',
                 objectFit: 'contain'
               }} 
             />
          </Box>
        </Box>
      </a>
    </Box>
  );
};

export default IleraBanner;
